import { createFileRoute, Link } from "@tanstack/react-router";

import { SiteLayout } from "@/components/SiteLayout";

const TITLE = "Termos de Uso — TrajetoFácil";
const DESCRIPTION =
  "Termos de uso do TrajetoFácil: natureza estimativa dos valores de pedágio e combustível, uso gratuito, limitações de responsabilidade e contato.";
const URL = "https://www.trajetofacil.com.br/termos";

export const Route = createFileRoute("/termos")({
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESCRIPTION },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: DESCRIPTION },
      { property: "og:type", content: "website" },
      { property: "og:url", content: URL },
      { name: "twitter:card", content: "summary" },
    ],
    links: [{ rel: "canonical", href: URL }],
  }),
  component: TermsPage,
});

function TermsPage() {
  return (
    <SiteLayout>
      <article className="space-y-8 text-base leading-7 text-foreground">
        <header>
          <h1 className="text-3xl font-extrabold tracking-tight">Termos de Uso</h1>
          <p className="mt-3 text-muted-foreground">
            Última atualização: setembro de 2026. Ao usar o TrajetoFácil, você concorda com as condições
            abaixo.
          </p>
        </header>

        <section className="space-y-3">
          <h2 className="text-xl font-bold">1. O serviço</h2>
          <p>
            O TrajetoFácil é uma calculadora gratuita de custos de viagem: distância, tempo, combustível e
            pedágio, com apoio de mapa interativo. O uso não exige cadastro e é oferecido no estado em que
            se encontra.
          </p>
        </section>

        <section className="space-y-3">
          <h2 className="text-xl font-bold">2. Natureza estimativa dos valores</h2>
          <p>
            Todos os valores exibidos — pedágio, combustível, tempo e custo total — são{" "}
            <strong>estimativas de referência</strong>, calculadas com base nas tarifas oficiais vigentes
            das praças de pedágio (ANTT e concessionárias estaduais), atualizadas automaticamente, e nos
            parâmetros informados por você.
          </p>
          <p>
            O valor efetivamente pago pode variar por sentido da rodovia, uso de tag de cobrança automática,
            descontos da concessionária, reajustes recentes, condições de trânsito e consumo real do
            veículo. Para decisões críticas (contratos, fretes fechados, reembolsos), confirme os valores
            nas fontes oficiais antes.
          </p>
        </section>

        <section className="space-y-3">
          <h2 className="text-xl font-bold">3. Limitação de responsabilidade</h2>
          <p>
            Não nos responsabilizamos por prejuízos decorrentes de divergências entre as estimativas e os
            valores efetivamente cobrados, nem por indisponibilidade temporária do serviço ou de serviços de
            terceiros (mapas, rotas e anúncios).
          </p>
        </section>

        <section className="space-y-3">
          <h2 className="text-xl font-bold">4. Uso aceitável</h2>
          <p>
            É vedado usar o site para sobrecarregar a infraestrutura, extrair dados em massa por meios
            automatizados ou qualquer finalidade ilícita. O descumprimento pode acarretar bloqueio de
            acesso.
          </p>
        </section>

        <section className="space-y-3">
          <h2 className="text-xl font-bold">5. Propriedade intelectual</h2>
          <p>
            A marca, o layout e os textos do TrajetoFácil são protegidos. Você pode citar e compartilhar
            links livremente; a reprodução integral do conteúdo exige autorização.
          </p>
        </section>

        <section className="space-y-3">
          <h2 className="text-xl font-bold">6. Contato</h2>
          <p>
            Dúvidas sobre estes termos podem ser enviadas pela{" "}
            <Link to="/contato" className="font-medium text-primary underline underline-offset-4">
              página de contato
            </Link>
            . Consulte também nossa{" "}
            <Link to="/privacidade" className="font-medium text-primary underline underline-offset-4">
              Política de Privacidade
            </Link>
            .
          </p>
        </section>
      </article>
    </SiteLayout>
  );
}
